import { createI18n } from 'vue-i18n'
import en from '../../language/english.js'
import vt from '../../language/vietnamese.js'
import es from '../../language/spanish.js'
import th from '../../language/thai.js'
import ms from '../../language/malay.js'
import id from '../../language/indonesian.js'
import fil from '../../language/filipino.js'
import zh from '../../language/chinese.js'
import ar from '../../language/arabic.js'

const messages = {

	'en': en,
	'vt' : vt,
	'es': es,
	'th': th,
	'ms': ms,
	'id': id,
	'fil': fil,
	'zh': zh,
	'ar': ar
};

const i18n = createI18n({
	locale: 'en',
	fallbackLocale: 'en',
	messages,
});

export default i18n;